/* eslint-disable react/no-danger */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import Body from '../partials/Body';

import styles from '../../../styles/blocks/image.module.scss';

const propTypes = {
    image: AppPropTypes.image.isRequired,
    caption: PropTypes.string,
    imageSize: PropTypes.string,
    isContainer: PropTypes.bool,
    fullWidth: PropTypes.bool,
    className: PropTypes.string,
    imgClassName: PropTypes.string,
    captionClassName: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    caption: null,
    imageSize: 'large',
    isContainer: false,
    fullWidth: false,
    className: null,
    imgClassName: null,
    captionClassName: null,
    containerClassName: null,
};

const ImageBlock = ({
    image,
    caption,
    imageSize,
    isContainer,
    fullWidth,
    className,
    imgClassName,
    captionClassName,
    containerClassName,
}) => {
    if (image === null) {
        return null;
    }
    const { alt = null } = image || {};
    const { width = 0, height = 0, url } = getImageAtSize(image, imageSize, false);
    const hasSize = width !== 0 && height !== 0;
    const finalCaption = caption || image.title;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.hasShape]: hasSize,
                    [styles.fullWidth]: fullWidth,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    'block-inner',
                    {
                        [styles.isContainer]: isContainer && !fullWidth,
                        [containerClassName]:
                            isContainer && !fullWidth && containerClassName !== null,
                    },
                ])}
            >
                <div
                    className={styles.shape}
                    style={{
                        paddingBottom: hasSize ? `${(height / width) * 100}%` : null,
                    }}
                >
                    <img
                        className={classNames([
                            styles.image,
                            { [imgClassName]: imgClassName !== null },
                        ])}
                        src={url}
                        alt={alt || caption}
                        width={hasSize ? width : null}
                        height={hasSize ? height : null}
                    />
                </div>
                {!isEmpty(finalCaption) ? (
                    <div
                        className={classNames([
                            styles.caption,
                            { [captionClassName]: captionClassName !== null },
                        ])}
                    >
                        {finalCaption !== null ? (
                            <Body className={styles.title} body={finalCaption} />
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;

export default ImageBlock;
